import React from "react";
import { useField } from "formik";
import { FormField, Select } from "semantic-ui-react";

export default function MySelectInput({
  label,
  isClearable = true,
  showError = true,
  isShowErrorBeforeTouch = false,
  isDisabled = false,
  limit = null,
  overwriteValue = null,
  ...props
}) {
  const [field, meta, helpers] = useField(props);
  return (
    <FormField
      error={(isShowErrorBeforeTouch || meta.touched) && !!meta.error}
      style={{ marginTop: 10, marginBottom: 10 }}
      disabled={isDisabled}
    >
      <label>{label}</label>
      <Select
        clearable={isClearable}
        value={overwriteValue || field.value || null}
        onChange={(e, d) => {
          if (!limit || d.value.length <= limit) {
            helpers.setValue(d.value);
          } else {
            helpers.setValue(d.value.slice(1));
          }
        }}
        onBlur={() => helpers.setTouched(true)}
        {...props}
      />
      {showError && (isShowErrorBeforeTouch || meta.touched) && meta.error ? (
        <div className="error-message">{meta.error}</div>
      ) : null}
    </FormField>
  );
}
